/* Focal 13.0.0: normal variant changes are server-rendered by product:rerender.
 * Refresh only after a browser back/forward-cache restore. Preserve the existing
 * form, quantity, app option fields, native AJAX cart, and loader buttons.
 */
(() => {
  window.addEventListener('pageshow', async (event) => {
    if (!event.persisted) return;

    const containers = document.querySelectorAll(
      'product-payment-container[data-auto-preorder-enabled="true"]'
    );
    await Promise.all(Array.from(containers, async (container) => {
      const form = container.closest('form');
      const input = form?.elements.namedItem('id');
      if (!form || !input?.value) return;
      const variantId = input.value;
      const url = new URL(container.dataset.autoPreorderProductUrl, window.location.origin);
      // Keep preview, locale, and market query parameters while fetching the selected variant.
      url.search = window.location.search;
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', container.dataset.autoPreorderSection);
      try {
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error(`Section refresh failed (${response.status})`);
        const htmlFragment = document.createRange().createContextualFragment(await response.text());
        if (!form.isConnected || input.value !== variantId) return;
        // A native input named "id" shadows form.id in browsers (Focal relies on this).
        const refreshedForm = htmlFragment.querySelector(`form[id="${form.getAttribute('id')}"]`);
        const refreshedButton = refreshedForm?.querySelector('[data-auto-preorder-variant]');
        if (!refreshedButton || refreshedButton.dataset.autoPreorderVariant !== variantId) return;
        // This non-bubbling event is the actual Focal 13 contract, verified in assets/theme.js.
        form.dispatchEvent(new CustomEvent('product:rerender', {
          detail: { htmlFragment, productChange: false }
        }));
        window.Shopify?.PaymentButton?.init();
      } catch (error) {
        // A failed network refresh keeps the last valid native state and never changes the variant ID.
        console.warn('[Akicon pre-order] Could not refresh the restored product state.', error);
      }
    }));
  });
})();
